import api from "@/lib/api";

const KEY = "pula_cookie_consent";

// Analytics only fires when the visitor has explicitly consented to analytics
// cookies. Anonymous aggregate events only — never any personal data.
export function analyticsAllowed() {
  try { return !!JSON.parse(localStorage.getItem(KEY) || "null")?.analytics; }
  catch { return false; }
}

export function track(event, path = window.location.pathname) {
  if (!analyticsAllowed()) return;
  api.post("/analytics/collect", { event, path }).catch(() => {});
}

// Fire a GA4 event via gtag. Consent-gated (analytics cookies only) and
// safely no-ops if gtag isn't loaded. Never pass personal data — low-cardinality
// params only (e.g. method, category, source). Used for GA4 Key Events.
export function gaEvent(name, params = {}) {
  if (!analyticsAllowed()) return;
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}
